import React from "react";
import Feature from "./Feature";

function Features() {

  return (
    <div className="py-12 lg:py-16" data-aos="fade-up">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:text-center">
          <h3 className="text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
            Features
          </h3>
          <p className="mt-4 max-w-2xl text-xl font-body leading-7 text-gray-800 lg:mx-auto">
            Describe your awesome features
          </p>
        </div>

        <div className="mt-10">
          <ul className="grid sm:grid-cols-2 md:grid-cols-3 md:row-gap-8">
            {[
              'Feature # 1',
              'Feature # 2',
              'Feature # 3',
              'Feature # 4',
              'Feature # 5',
              'Feature # 6',
            ].map((item, index) => (
              <li key={index}>
                <Feature
                  featureTitle={item}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Features;